export const presentationEvents = {
  channels: {},

  subscribe: (channel, listener) => {
    if (presentationEvents.channels[channel] && Array.isArray(presentationEvents.channels[channel])) {
      presentationEvents.channels[channel].push(listener)
    } else {
      presentationEvents.channels[channel] = [listener]
    }
  },

  publish: function (channel, info = {}) {
    if (!presentationEvents.channels[channel]) {
      return
    }

    presentationEvents.channels[channel].forEach((listener) => {
      info = info ?? {}
      listener(info)
    })
  },

  clear: function () {
    for (const prop of Object.getOwnPropertyNames(presentationEvents.channels)) {
      delete presentationEvents.channels[prop]
    }
  }
}
